'use client'
import { Fragment, ReactNode } from 'react'
import { usePathname } from 'next/navigation'
import {
  PROTECTED_ROUTES,
  NEARBY_LABS_PAGE,
  LEAD_PAGE,
  LEAD_PAGE_INITIAL,
} from '@/utils/constants'

export const FOOTER_HIDDEN_PAGES = [
  ...PROTECTED_ROUTES,
  NEARBY_LABS_PAGE,
  LEAD_PAGE,
  LEAD_PAGE_INITIAL,
]

// Decided on the client because headers() freezes at the last full page load: the root layout is reused on soft navigation, so a server check kept the footer visible after linking into a hidden page.
const FooterVisibility = ({ children }: { children: ReactNode }) => {
  const pathname = usePathname() || '/'

  if (FOOTER_HIDDEN_PAGES.some((route) => pathname.startsWith(route))) {
    return null
  }

  return <Fragment>{children}</Fragment>
}

export default FooterVisibility
